import { BrandIcon } from '@jotta/ui/BrandIcon'
import { Stack } from '@jotta/ui/Stack'
import type { BrandThemeIcon } from '@jotta/types/Brand'
import { FormattedContent } from '@jotta/ui/FormattedContent'
import { RadixModal } from '@jotta/ui/RadixModal'
import { Trans } from '@lingui/macro'
import * as Dialog from '@radix-ui/react-dialog'
import { observer } from 'mobx-react-lite'
import SvgFileUpload from '@jotta/ui/SvgFileUpload'
import SvgMinusCircle from '@jotta/ui/SvgMinusCircle'

export interface UploadOverlayProps {
  uploadsAllowed?: boolean
  open?: boolean
}
export const UploadOverlay = observer<UploadOverlayProps>(
  function UploadOverlay({ uploadsAllowed = false, open = false, ...props }) {
    const icon: BrandThemeIcon = uploadsAllowed ? SvgFileUpload : SvgMinusCircle
    return (
      <RadixModal open={open} variant="layout.modalBackgroundLightFixed">
        <Dialog.Content
          sx={{
            variant: 'layout.center',
          }}
        >
          <Stack
            gap={4}
            sx={{
              alignItems: 'center',
              justifyItems: 'center',
            }}
          >
            <BrandIcon
              icon={icon}
              sx={{
                color: '#777',
                width: 204,
                height: 170,
              }}
            />
            <FormattedContent center>
              <h4>
                {uploadsAllowed ? (
                  <Trans>Drop files here to upload</Trans>
                ) : (
                  <Trans>Uploads to this folder is not allowed</Trans>
                )}
              </h4>
            </FormattedContent>
          </Stack>
        </Dialog.Content>
      </RadixModal>
    )
  },
)
